'use strict';

var toastr = require('toastr');
var _ = require('lodash');
function ConfigurationEntityService($q, restangular, $http, $log) {
  var CONFLICT_ERROR_CODE = 409;
  var id;
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationEntityService: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicate record exists');
    } else {
      var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationEntityService: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  function saveConfigurationEntity(entity) {
    var payload = {
      id: id,
      entities: preparePayload(entity)
    };
    return restangular.one('staticdata').one('entity').one('' + payload.id).customPUT(payload).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  function removeEntity(entity) {
    if (!entity.length) {
      var deferred = $q.defer();
      deferred.resolve();
      return deferred.promise;
    }
    var payload = {
      entities: preparePayload(entity)
    };
    return $http({
      method: 'DELETE',
      url: restangular.service('staticdata').one('entity').getRestangularUrl(),
      data: payload,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  function preparePayload(entity) {
    return _.transform(entity, function (result, item) {
      var newEntity = _.clone(item);
      delete newEntity.uid;
      delete newEntity.dataindex;
      delete newEntity._old;
      delete newEntity._original;
      result.push(newEntity);
    });
  }
  function setId(newId) {
    id = newId;
  }
  return {
    saveConfigurationEntity: saveConfigurationEntity,
    removeEntity: removeEntity,
    setId: setId
  };
}
ConfigurationEntityService.$inject = ['$q', 'Restangular', '$http', '$log'];
module.exports = ConfigurationEntityService;